export const getAdminToken = () => localStorage.getItem("admin_token");
export const isLoggedIn    = () => !!getAdminToken();
export const logout        = () => localStorage.removeItem("admin_token");
